"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function textToListIndex(value, textIndex) {
    let offset = 0;
    for (let i = 0; i < value.length; i++) {
        const ch = value[i];
        if (textIndex === offset && 'char' in ch) {
            return i;
        }
        else if ('char' in ch) {
            offset++;
        }
    }
    return offset;
}
exports.default = textToListIndex;
//# sourceMappingURL=textToListIndex.js.map